module.exports = __webpack_public_path__ + "img/010.618fdcc2.jpg";